<template>
    <form class="sari-form" :class="flavor" @submit.prevent="book()">
        <b-loading :active="status.loading || !status.ready" />
        <section v-if="!hasData">
            {{ t["nocourses"] }}
        </section>
        <section v-if="hasData">
            <pgs-widget :data="data" :languageId="languageId" :form="form" @selected="selected" v-if="type == 'pgs'" />
            <vku-widget :data="data" :languageId="languageId" :form="form" v-if="type == 'vku'" />
        </section>
        <section class="mt-5" v-show="hasData && (type == 'vku' || hasSelection)">
            <h1 class="title is-4">{{ t["title.contact"] }}</h1>
            <div class="columns is-multiline">
                <!-- <div class="column is-full" v-if="languageId == 'en'">
                    <b-field :label="t['location']">
                        <b-select v-model="form.location" expanded>
                            <option value="zurich" selected>Zürich</option>
                            <option value="lachen">Lachen</option>
                        </b-select>
                    </b-field>
                </div> -->
                <div class="column is-half">
                    <b-field :label="t['licenseid']" :message="t['licenseid.hint']">
                        <b-input v-model="licenseString" :custom-class="e['licenseId'] ? 'is-danger' : ''" expanded />
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['birthdate']">
                        <b-input v-model="form.birthdate" placeholder="DD.MM.YYYY" maxlength="10" :custom-class="e['birthdate'] ? 'is-danger' : ''" expanded :has-counter="false" />
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['name']">
                        <b-input v-model="form.name" :custom-class="e['name'] ? 'is-danger' : ''" expanded />
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['street']" expanded>
                        <b-input v-model="form.street" :custom-class="e['street'] ? 'is-danger' : ''" expanded />
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['city']">
                        <b-input v-model="form.city" :custom-class="e['city'] ? 'is-danger' : ''" expanded />
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['email']">
                        <b-input v-model="form.email" type="email" :custom-class="e['email'] ? 'is-danger' : ''" expanded />
                        <p class="control">
                            <span class="button is-static">@</span>
                        </p>
                    </b-field>
                </div>
                <div class="column is-half">
                    <b-field :label="t['phone']">
                        <b-input v-model="form.phone" type="tel" placeholder="### ### ## ##" maxlength="20" :custom-class="e['phone'] ? 'is-danger' : ''" />
                    </b-field>
                </div>
                <div class="column is-full">
                    <b-field :label="t['comments']">
                        <b-input type="textarea" rows="4" v-model="form.note" />
                    </b-field>
                </div>
                <div class="column is-full has-text-centered">
                    <b-checkbox v-model="form.agb" :class="{ 'is-danger': e['agb'] }">
                        <span v-if="languageId != 'en'">{{ t["agb"] }} <a href="https://www.drivingteam.ch/agb" target="_blank">AGB</a> *</span>
                        <span v-if="languageId == 'en'">{{ t["agb"] }} <a href="https://www.drivingteam.ch/gtc" target="_blank">GTC</a> *</span>
                    </b-checkbox>
                </div>
            </div>
        </section>
        <b-message type="is-danger" size="is-small" class="mt-2" v-if="status.ready && status.error">
            {{ status.error }}
        </b-message>

        <div class="mt-4" v-show="hasData && (type == 'vku' || hasSelection)">
            <b-button type="is-primary" :class="flavor" native-type="submit" expanded>{{ t["signup"] }}</b-button>
            <p class="mt-2" style="font-size: smaller">
                {{ t["spamnote"] }} <a href="mailto:info@drivingteam.ch">info@drivingteam.ch</a>.
            </p>
        </div>
    </form>
</template>

<script>
import Widget from "../Widget";
import PgsWidget from "./Widget.Pgs";
import VkuWidget from "./Widget.Vku";
import Resources from "./Resources";

export default {
    props: ["apiKey", "productId", "sectionId", "languageId", "redirectUrl", "flavor", "widgetLocation"],
    mixins: [Widget],
    components: { PgsWidget, VkuWidget },
    data: () => ({
        data: null,
        type: null,
        t: {},
        e: {},
        hasSelection: false,
        hasData: false,
        licenseString: null,
        form: {
            licenseId: null,
            birthdate: null,
            location: "zurich",
            name: null,
            street: null,
            city: null,
            note: null,
            email: null,
            phone: null,
            agb: false,
            onDemand: null,
            rentScooter: false,
            rentMotorcycle: false,
            courseIds: []
        }
    }),
    created() {
        this.fetch();
        this.t = Resources[this.languageId == "en" ? "en" : "de"];
        this.hasSelection = (this.type == "vku");
    },
    mounted() {
        const widget = document.querySelector("sari-widget");

        if (widget) {
            widget.setAttribute("style", "display:block;max-width:100%;font-size:16px");
            widget.parentElement.setAttribute("style", "left:0");
        }
    },
    methods: {
        selected() {
            this.hasSelection = true;
        },
        async fetch() {
            const payload = {
                section: this.sectionId,
                language: this.languageId || "de",
            };

            this.data = await this.api("get", payload);

            if (this.data.status && this.data.status !== "OK") {
                this.status.error = "Unable to load data.";
                this.status.loading = false;

                return;
            }

            this.type = this.sectionId.substring(0, 3);
            this.hasData = (this.data.length > 0);

            this.status.ready = true;
            this.status.loading = false;
        },
        async book() {
            this.status.loading = true;
            this.status.error = null;
            this.e = {};

            const req = {
                section: this.sectionId,
                language: this.languageId || "de",
                flavor: this.flavor,
                widgetLocation: this.widgetLocation,
                ...this.form,
            };

            const result = await this.api("book", req);

            if (result.status !== "OK") {
                this.status.error = result.message || this.error(result);
                this.status.loading = false;
            } else if (this.languageId == "en")
                location.href = "/thank-you-road-awareness";
            else if (this.sectionId == "vku-zurich")
                location.href = "/danke-vku-zurich";
            else if (this.sectionId == "vku-lachen")
                location.href = "/danke-vku-lachen";
            else if (this.sectionId == "pgs-zurich")
                location.href = "/danke-grundkurs-zurich";
            else if (this.sectionId == "pgs-lachen")
                location.href = "/danke-grundkurs-lachen";
            else
                location.href = this.redirectUrl;
        },
        error(result) {
            switch (result.status) {
                case "BAD_REQUEST":
                    result.properties.forEach(key => this.e[key] = true);
                    return this.t["error.badreq"];
                case "PERSON_NOT_FOUND":
                    return this.t["error.notfound"];
                case "MISMATCH_BIRTHDATE_FABERID":
                    return this.t["error.mismatch"];
                case "PERSON_ALREADY_ADDED":
                    return this.t["error.dupe"];
                case "COURSE_PERSON_DEADLINE_VIOLATED":
                    return this.t["error.late"];
                case "INVALID_COURSE_COMBINATION":
                    return this.t["error.invalid"];
                default:
                    return this.t["error.prefix"] + result.status;
            }
        }
    },
    watch: {
        licenseString(value) {
            value = value || "";
            value = value.replace(/\./g, "");
            value = value.replace(/,/g, "");
            value = value.replace(/ /g, "");

            this.form.licenseId = value;
        }
    }
}
</script>

<style lang="scss">
    .sari-form {
        max-width: 525px;
        font-size: 16px;
        padding-bottom: 75px;
        display: block;

        @media (max-width: 980px) {
            padding-left: 15px;
            padding-right: 15px;
        }

        .subtitle {
            opacity: .75;
            margin-top: -1rem !important;
            font-weight: bold;
        }
    }

    .sari-form:not(.pollice) {
        @import "Widget.scss";
    }
    .sari-form.pollice {
        @import "Widget.Pollice.scss";
    }
</style>